<script>
import Vue from 'vue'
import { Table } from 'ant-design-vue'
const T = Table

Vue.component('a-table', Table)
let dragStartHead = void 0
let dragStartBody = void 0
const swapArr = (arr, index1, index2) => {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0]
  return arr
}
// 目前锁定的列数
let lockNum = 0
export default {
  name: 'ml-table',
  data() {
    return {
      localComponents: {
        header: {
          cell: this.initResizeTable()
        }
      },
      // selectedRows: [],
      selectedRowKeys: []
    }
  },
  props: Object.assign({}, T.props, {
    // 是否能拖拽改变列顺序
    canChangeColOrder: {
      type: Boolean,
      default: false
    },
    // 是否能拖拽改变列宽
    canChangeColWidth: {
      type: Boolean,
      default: true
    },
    // 是否能拖拽改变行排序
    canChangeRowOrder: {
      type: Boolean,
      default: false
    },
    // 是否能点击锁定表格列
    canFixedHead: {
      type: Boolean,
      default: false
    },
    // size: {
    //   type: String,
    //   default: 'small'
    // },

    bordered: {
      type: Boolean,
      default: true
    },

    columns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    isInsert: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object | Boolean,
      default: false
    },
    rowKey: {
      type: String,
      default: 'key'
    },
    // 选择的行的key的值，用来处理点击高亮
    selectRowKey: {
      type: String | Number,
      default: ''
    },
    // 是否自定义设置行宽 用来处理自定义字段。
    isAutoWidth: {
      type: Boolean,
      default: false
    },
    chooseArr: {
      type: Array,
      default: () => []
    }
  }),
  watch: {
    // selectedRows: {
    //   handler(val) {
    //     console.log(val)
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  mounted() {
    if (this.canChangeColOrder) {
      this.initColOrder()
    }
    if (this.canChangeRowOrder) {
      this.initBodyOrder()
    }
    this.initFixTableWidth()
  },
  methods: {
    cancelChooseArr() {
      console.log(1111)
      this.$emit('cancelChooseArr', [])
    },
    initResizeTable() {
      const draggingMap = {}
      this.initCanFixedColumn()
      this.columns.forEach((col) => {
        draggingMap[col.dataIndex] = col.width
      })
      const draggingState = Vue.observable(draggingMap)
      const temp = (h, props, children) => {
        let thDom = null
        const { key, ...restProps } = props
        const index = this.columns.findIndex((col) => {
          const k = col.dataIndex || col.key
          return k === key
        })
        const col = this.columns[index] || {}
        if (!this.canChangeColWidth) {
          return <th {...restProps}>{this.initHeader(col, children, index)}</th>
        }
        if (this.canFixedHead) {
          if (col.key && !col.width) {
            this.$set(col, 'width', col.title.length * 30)
          }
          if (col.key && !col.headIcon) {
            this.$set(col, 'headIcon', 'unlock')
          }
        }
        const onDrag = (x) => {
          draggingState[key] = 0
          col.width = Math.max(x, col.title.length * 3)
          this.$emit('onChangeColWidth', col)
          this.$forceUpdate()
        }
        const onDragstop = () => {
          draggingState[key] = thDom.getBoundingClientRect().width
        }
        return (
          <th
            {...restProps}
            v-ant-ref={(r) => (thDom = r)}
            width={col.width}
            class="resize-table-th"
          >
            {this.initHeader(col, children, index)}
            <vue-draggable-resizable
              key={col.dataIndex}
              class="table-draggable-handle"
              w={10}
              x={draggingState[key] || col.width}
              z={1}
              axis="x"
              draggable={true}
              resizable={false}
              onDragging={onDrag}
              onDragstop={onDragstop}
            ></vue-draggable-resizable>
          </th>
        )
      }
      return temp
    },
    initColOrder() {
      this.commonDrop('ant-table-column-title', true, (event, dragEndEle) => {
        event.preventDefault()
        if (!dragStartHead) {
          return
        }
        dragEndEle = event.target
        const startIndex = this.columns.findIndex((_res) => {
          return _res.title === dragStartHead.innerText
        })
        const endIndex = this.columns.findIndex((_res) => {
          return _res.title === dragEndEle.innerText
        })
        this.columns = swapArr(this.columns, startIndex, endIndex)
        this.$emit('onChangeColSort', startIndex, endIndex)
      })
    },
    initBodyOrder() {
      this.commonDrop('ant-table-row', false, (event, dragEndEle) => {
        event.preventDefault()
        if (!dragStartBody) {
          return
        }
        dragEndEle = event.target.parentNode
        const startIndex = parseInt(dragStartBody.getAttribute('data-row-key'))
        const endIndex = parseInt(dragEndEle.getAttribute('data-row-key'))
        if (this.isInsert) {
          const delArr = this.dataSource.splice(startIndex, 1)
          this.dataSource.splice(startIndex > endIndex ? endIndex : endIndex - 1, 0, delArr[0])
        } else {
          this.dataSource = swapArr(this.dataSource, startIndex, endIndex)
        }
        this.$nextTick(() => {
          const table = this.$refs.table.$el
          let rows = table.getElementsByClassName('ant-table-row ')
          rows = Array.prototype.slice.call(rows)
          rows.forEach((res, index) => {
            res.setAttribute('data-row-key', index)
          })
        })
        // this.
        // dragStartBody.setAttribute("data-row-key", endIndex);
        // dragEndEle.setAttribute("data-row-key", startIndex);
        this.$emit('onChangeRowSort', startIndex, endIndex)
      })
    },
    /**
     * bindElement 绑定拖拽区域
     * isHead 是否为头部
     * callback 拖拽完成的回调
     */
    commonDrop(bindElement, isHead, callback) {
      this.$nextTick(() => {
        const header = this.$refs.table.$el
        let ths = header.getElementsByClassName(bindElement)
        ths = Array.prototype.slice.call(ths)
        let dragEndEle = void 0
        ths.forEach((res) => {
          res.setAttribute('draggable', true)
          res.addEventListener(
            'dragstart',
            (event) => {
              if (isHead) {
                dragStartHead = event.target
                dragStartBody = null
              } else {
                dragStartBody = event.target
                dragStartHead = null
              }
            },
            false
          )
          res.addEventListener(
            'dragend',
            (event) => {
              // 重置透明度
              event.target.style.opacity = ''
            },
            false
          )
          res.addEventListener(
            'dragover',
            (event) => {
              event.preventDefault()
            },
            false
          )
          res.addEventListener(
            'dragenter',
            (event) => {
              event.preventDefault()
            },
            false
          )
          res.addEventListener(
            'drop',
            (event) => {
              callback(event, dragEndEle)
            },
            false
          )
        })
      })
    },
    // 表头自定义样式
    initHeader(col, children, index) {
      if (col && col.headIcon && index < 5) {
        return (
          <div class="icon-wapper">
            <span class="ant-table-column-title">{col.title}</span>
            <a-icon
              type={col.headIcon}
              class="icon"
              onClick={() => this.headIconClick(col)}
            ></a-icon>
          </div>
        )
      }
      return children
    },
    initCanFixedColumn() {
      if (this.canFixedHead) {
        this.columns.forEach((res) => {
          if (res.key === 'action') {
            // 操作栏默认锁定
            lockNum += 1
            this.$set(res, 'headIcon', 'lock')
          } else {
            this.$set(res, 'headIcon', 'unlock')
          }
        })
      }
    },
    headIconClick(column) {
      // 操作栏固定在左侧，不允许解锁
      if (column.key === 'action') {
        return
      }
      let isLock = column.headIcon === 'lock'
      isLock ? lockNum-- : lockNum++
      this.$set(column, 'headIcon', isLock ? 'unlock' : 'lock')
      let clickColIndex = this.columns.findIndex((res) => res.dataIndex === column.dataIndex)
      /* if (typeof clickColIndex !== 'undefined') {
        this.columns[clickColIndex] = column
      }
      this.columns = swapArr(this.columns, isLock ? lockNum : lockNum - 1, clickColIndex )
      this.columns.forEach(res => {
        this.$set(res, 'fixed', res.headIcon === 'lock')
      }) */
      if (clickColIndex !== -1) {
        if (isLock) {
          this.columns.forEach((res, index) => {
            if (index >= clickColIndex) {
              this.$set(res, 'headIcon', 'unlock')
              this.$set(res, 'fixed', false)
            }
          })
        } else {
          this.columns.forEach((res, index) => {
            if (index <= clickColIndex) {
              this.$set(res, 'headIcon', 'lock')
              this.$set(res, 'fixed', true)
            }
          })
        }
      }
      this.$forceUpdate()
      this.initFixTableWidth()
    },
    // 表格选中行样式改变
    // setRowClassName(record) {
    //   return record[this.rowKey] === this.selectRowKey ? 'clickRowStyl' : ''
    // },
    setRowClassName(record, index) {
      let color = ''
      if (index % 2 === 1) color = 'secondColor'
      if (index % 2 === 0) color = 'fitstColor'
      if (record[this.rowKey] === this.selectRowKey) color = 'clickRowStyl'
      return color
    },
    initHeadWidth() {
      this.columns.forEach((res, index, arr) => {
        if (!res.width && index !== arr.length - 1) {
          res.width = res.title.length * 25
        }
      })
    },
    initFixTableWidth() {
      this.$nextTick(() => {
        let w = 0
        let node = this.$refs.table.$el.querySelector('.ant-table-fixed-left')
        let fixtableThead = this.$refs.table.$el.querySelector('.ant-table-thead')
        let thDatas = fixtableThead.querySelectorAll('th')
        if (node) {
          this.columns.forEach((item) => {
            if (item.fixed) {
              for (let i = 0, len = thDatas.length; i < len; i++) {
                if (thDatas[i].getAttribute('key') == item.dataIndex) {
                  let thW = thDatas[i].getBoundingClientRect().width
                  w += thW
                  break
                }
              }
              // w += item.width
            }
          })
          for (let i = 0, len = thDatas.length; i < len; i++) {
            if (thDatas[i].getAttribute('key') == 'selection-column') {
              let thW = thDatas[i].getBoundingClientRect().width
              w += thW
              break
            }
          }

          if (w) {
            let tableFixed = node.querySelectorAll('.ant-table-fixed')
            ;[].forEach.call(tableFixed, function(item) {
              item.style.width = w + 'px'
            })
          }
        }
      })
    }
  },

  render() {
    const props = {}
    Object.keys(T.props).forEach((k) => {
      this[k] && (props[k] = this[k])
      return props[k]
    })
    return (
      <div class="mlTable-div">
        <a-table
          ref="table"
          class="ml-table-wrapper1"
          components={this.localComponents}
          pagination={this.pagination}
          row-class-name={this.setRowClassName}
          {...{ props, scopedSlots: { ...this.$scopedSlots }, on: this.$listeners }}
        >
          {Object.keys(this.$slots).map((name) => (
            <template slot={name}>{this.$slots[name]}</template>
          ))}
        </a-table>

        <div class="mlTable-pop">
          <a-popover placement="right" visible={this.chooseArr.length >= 2} trigger="click">
            <template slot="content">
              <a-icon type="info-circle" theme="filled" style="color: #3a7fbc" />
              <span style="margin-left: 2px">
                已选 <span style="margin: 0 1px;">{this.chooseArr.length}</span> 项
              </span>

              <a-button style="margin-left: 6px;" type="link" onClick={this.cancelChooseArr}>
                取消选择
              </a-button>
            </template>
          </a-popover>
        </div>
      </div>
    )
  }
}
</script>
<style lang="less">
.mlTable-div {
  position: relative;

  .mlTable-pop {
    position: absolute;
    left: 30px;
    top: 17px;
    z-index: 100;
  }
}

.ant-table-empty .ant-table-body {
  overflow-x: hidden !important;
}

.ml-table-wrapper1 {
  .resize-table-th {
    position: relative;
    background-color: #d0edff !important;
    .table-draggable-handle {
      height: 100% !important;
      bottom: 0;
      left: auto !important;
      right: -5px;
      cursor: col-resize;
      touch-action: none;
    }
  }
  .icon-wapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .anticon-lock {
    color: #4a90e2;
  }

  .clickRowStyl {
    background-color: #fff1b8 !important;
    td {
      background-color: #fff1b8 !important;
    }
  }
  .fitstColor {
    background-color: #ffffff !important;
    td {
      background-color: #ffffff !important;
    }
  }
  .secondColor {
    background-color: #f8f8f8 !important;
    td {
      background-color: #f8f8f8 !important;
    }
  }
  .ant-table-row-selected {
    background-color: #fff1b8 !important;
    td {
      background-color: #fff1b8 !important;
    }
  }
  .ant-table-thead {
    background-color: #d0edff;
  }

  .ant-table-selection-column {
    width: 44px !important;
    height: 32px !important;
    padding: 0 !important;
  }

  .ant-table colgroup > col.ant-table-selection-col {
    width: 44px;
  }
}
</style>

<style>
.ant-table-row {
  min-height: 32px !important;
  height: 32px;
}

.ant-popover {
  z-index: 1000;
}

.ant-popover-inner-content {
  padding: 3px 10px;
}
</style>
